import { reactive } from "vue";
import {
  createCourseSelection,
  SELECTION_KEY,
} from "./utils/courseSelection.mjs";

let storage;
try {
  storage = window.localStorage;
} catch {
  /* Storage is optional. */
}
export const courseSelection = createCourseSelection({ storage, reactive });
window.addEventListener("storage", (event) => {
  if (event.key === SELECTION_KEY && event.newValue)
    courseSelection.hydrate(event.newValue);
});
